module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/analytics-03c346b20933f9ac480dd70825399504.png";